import AppSettings from "../AppSettings";
import gaskets from "./gasket/GasketInfo.json";
import { parseFraction } from "./gasket/dimensions";

function isGasket(part) {
  if (!part || !part.attributes) return false;
  return part.attributes.some(attr => attr.name === "Unit" && attr.value === "Pre-Molded");
}

function getGasket(partId) {
  partId = partId ? partId.toUpperCase(partId) : "";
  const gasket = gaskets.find(part => part.partId === partId);
  return gasket;
}

function customPartType(part) {
  if (part.custom) return part.custom;

  if (isGasket(part)) return "Gasket";
  return "";
}

function isCustomPart(part) {
  return !!customPartType(part);
}

function hasCustomParts(parts) {
  return parts.filter(part => isCustomPart(part)).length > 0;
}

function profileUrl(gasket) {
  return `${AppSettings.ImageService}/catalog/graphics%2fDrawings%5c${gasket.profile}.png`;
}




export { isGasket, getGasket, customPartType, isCustomPart, hasCustomParts, profileUrl };
